import React from 'react';
import { useTranslation } from 'react-i18next';
import * as style from './WalletDownload.style';
import * as styleH5 from './WalletDownload.style.h5';
import {useStore} from "react-redux";
import {IState} from "../../store/reducer";
import Modal from "../modal/Modal";
import {IWallet} from "../../contract/config";
import {IOpenModal} from "../openModal";
import useWidthChange from "../../hooks/useWidthChange";

export type IWalletDownload = {
    wallet_info: IWallet
    onClose?(): void
}
export default function WalletDownload(props: IWalletDownload & IOpenModal) {
    const {t} = useTranslation();
    const store = useStore<IState>();
    const storeData = store.getState();
    const { isH5 } = useWidthChange();
    const {IntrolItem, Title, WalletDownloadBtn, WalletDownloadStyle} = style;

    return (
        <Modal disableHead={true}
               disabledBorder={true}
               close={props.destoryComponent}
               title={"Download Wallet"}
               isH5={isH5}
               style={isH5 ? {} : {width: "420px", padding: "0"}}>
            <WalletDownloadStyle>
                <div className={"left"}>
                    <div className={"content"}>To continue, please download {props.wallet_info.name} first.</div>
                    <WalletDownloadBtn href={props.wallet_info?.download} target={"_blank"}>
                        <img src={props.wallet_info?.icon} className={"walletIcon"} alt=""/>
                        <span className={"text"}>{props.wallet_info?.name}</span>
                    </WalletDownloadBtn>
                </div>
            </WalletDownloadStyle>
        </Modal>
    )
}
